import { buildLink } from '@/utils';
import { Alert, AlertDescription, AlertTitle, Button } from '@e2n/ui';
import {
  faTriangleExclamation,
  faWandMagicSparkles,
} from '@fortawesome/pro-regular-svg-icons';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function NextSteps() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const showFristenWarning = Boolean(searchParams.get('warning'));

  const handleNavigation = (to: 'create' | 'mitarbeiterList') => {
    if (to === 'create') {
      navigate('/mitarbeiter/create');
    } else if (to === 'mitarbeiterList') {
      window.location.replace(buildLink('mitarbeiterListe'));
    }
  };

  return (
    <div className="flex flex-col gap-4 items-center w-96">
      {showFristenWarning && (
        <Alert variant="warning" className="w-full">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <AlertTitle>
            {t('domain.mitarbeiter.create.success.warning.title')}
          </AlertTitle>
          <AlertDescription>
            {t('domain.mitarbeiter.create.success.warning.description')}
          </AlertDescription>
        </Alert>
      )}
      <Button
        className="flex gap-3 h-16 p-4 bg-neutrals-200 rounded-xl text-neutrals-900 hover:bg-neutrals-300 w-full"
        onClick={() => handleNavigation('create')}>
        <FontAwesomeIcon icon={faWandMagicSparkles} />
        <span>
          {t('domain.mitarbeiter.create.success.nextSteps.assistent')}
        </span>
        <FontAwesomeIcon
          icon={faArrowRight}
          className="ml-auto text-primary-blue-600 size-4"
        />
      </Button>

      <Button
        variant="ghost-primary"
        onClick={() => handleNavigation('mitarbeiterList')}>
        {t('domain.mitarbeiter.create.success.nextSteps.back')}
      </Button>
    </div>
  );
}
